export default __webpack_public_path__ + "7fb672733ad0181ee22bb2ee6993b892.svg";